import { LandingInterestRecommendationsBlock } from '../landing-interest-recommendations-block.large';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function GeneralInterestDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { actions, tags, visibleGeneralInterestRecommendations } = data;
  if (!visibleGeneralInterestRecommendations?.length) return null;
  return (
    <LandingInterestRecommendationsBlock
      onOpenOfferTag={actions.openOfferTag}
      recommendations={visibleGeneralInterestRecommendations}
      tags={tags}
    />
  );
}
